import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GaTrackingEventLabel } from '../../constants';

export class GATrackingPdpBrandInteractionEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PdpBrandInteraction,
      label: GaTrackingEventLabel.PdpBrandInteraction.replace('{brand}', this.payload.label),
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
